import { render, staticRenderFns } from "./AcceptMonitoringDialog.vue?vue&type=template&id=67cb089a&scoped=true"
import script from "./AcceptMonitoringDialog.vue?vue&type=script&lang=ts"
export * from "./AcceptMonitoringDialog.vue?vue&type=script&lang=ts"
import style0 from "./AcceptMonitoringDialog.vue?vue&type=style&index=0&id=67cb089a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cb089a",
  null
  
)

export default component.exports